import React, { createRef } from "react";
import { Spinner } from "@abb/abb-common-ux-react";
import { IInstrumentDetails } from "../../models/measurement/InstrumentDetails";
import { IKeyedInDetails } from '../../models/measurement/KeyedInDetails';
import { AppContextConsumer } from './MeasurementLanding';
import { ICalculatedDetails } from "../../models/measurement/CalculatedDetails";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import graphPlaceholder from "../../assets/trend.png";


import { ChartTypes, DateUnits, ISeries, ITrendDataLimit, Trend, TrendMarkerTypes } from "@iom/trend";
import _ from "lodash";
import { MeasurementSetting } from "../../models/settings/MeasurementSettings";
import InfiniteScroll from "react-infinite-scroll-component";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import { ISampleKeyedInDetails } from "../../models/measurement/SampleKeyedInDetails";
import Utility from "../shared/Utility";
import NoDataFound from "../shared/NoDataFound";
import NoTrendToDisplay from "../shared/NoTrendToDisplay";

interface IMeasurementTable {
    details?: boolean;
    measuredSection?: boolean;
    keyedInSection?: boolean;
    calculatedSection?: boolean;
    keyedInSampleData?: ISampleKeyedInDetails[];
    selectedInstrumentDetail?: IInstrumentDetails;
    selectedKeyedInDetails?: IKeyedInDetails;
    selectedCalculatedDetails?: ICalculatedDetails;
    onMeasuredPositionChange?: (index: number) => void;
    onKeyedInPositionChange?: (index: number) => void;
    isLoadingText: boolean;
    settings: MeasurementSetting;
    thresholdSettings: IThresholdSettings[];
}

interface IState {
    totalmeasuredproperty: any,
    measuredproperty: any,
    activeIndex: number,
    selectedKeyedInDetails?: IKeyedInDetails,
    activeMeasuredIndex?: number,
    series: any,
    chartType: ChartTypes,
    dateUnit: DateUnits,
    dateUnitCount: number,
    start?: Date,
    end?: Date

}
export default class GraphMeasurementTable extends React.Component<IMeasurementTable, IState> {
    start = new Date(2019, 0, 1, 0, 0, 0, 0);
    end = new Date(2019, 0, 5, 0, 0, 0, 0);
    private minXValue: number;
    private maxXValue: number;


    private _autolineScroll: any;
    private _mount: boolean;
    private _hasData: boolean = true;
    private _page: any = 1;

    constructor(props: IMeasurementTable) {
        super(props);
        this._autolineScroll = React.createRef();
        this.onScroll = this.onScroll.bind(this);

        let xValue: number[] = [];

        this.minXValue = 0;
        this.maxXValue = 200;

        this.state = {
            totalmeasuredproperty: [],
            measuredproperty: [],
            activeIndex: this.props.selectedKeyedInDetails?.setPositionVal,
            selectedKeyedInDetails: this.props.selectedKeyedInDetails,
            activeMeasuredIndex: this.props.selectedInstrumentDetail?.setPositionVal,
            chartType: this.props.settings?.selectedGraphType?.name,
            dateUnit: 'Day',
            dateUnitCount: 4,
            start: this.start,
            end: this.end,
            series: [
                {
                    name: 'Position',
                    color: '#5ABFAE',
                    id: '1',
                    markerStyle: {
                        type: this.state?.chartType ==="Bar" ? "None" : "Circle"
                    },
                    yAxis: {
                        min: this.minXValue,
                        max: this.maxXValue,
                        decimalPlaces: this.props.selectedKeyedInDetails?.decimals
                    },
                    isShownInChart: true,
                    points: this.generateOrdinalData1(0, 20, 1, 0, 100)  // String
                }
            ]
        }
    }

    componentDidMount() {
        this.createMeasuredColumnData();
        this._hasData = true;
    }

    componentDidUpdate(prevProps: IMeasurementTable) {
        // state upadte for activeIndex
        if (this.state.activeIndex !== this.props.selectedKeyedInDetails?.setPositionVal) {
            this.setState({
                activeIndex: this.props.selectedKeyedInDetails?.setPositionVal
            })
        }

        if (this.props.selectedKeyedInDetails?.id !== prevProps.selectedKeyedInDetails?.id) {
            this.setState({
                activeIndex: 0
            })
        }
        if (this.props.selectedInstrumentDetail?.id !== prevProps.selectedInstrumentDetail?.id) {
            this.setState({
                activeMeasuredIndex: 0
            })
        }

        if (prevProps.selectedInstrumentDetail != this.props.selectedInstrumentDetail) {
            this.createMeasuredColumnData();
            this._hasData = true;
        }
    }

    onScroll(e: any) {
        const elm = document.getElementById("scrollBar").scrollLeft;
        document.getElementById("autolinescroll").scrollLeft = elm;
    }


    // MEASURED START
    private createMeasuredColumns = () => {
        const items: any[] = [];
        const countData = this.props.selectedInstrumentDetail?.countData.find(x => x.selected);
        if (this.props.details) {
            if (countData !== undefined) {
                const directions = countData.directions.find(x => x.selected);
                for (let index = 1; index <= directions?.maxCount; index++) {
                    items.push(<th scope="col" key={index}></th>);
                }
            }
        } else {
            if (this.props.selectedInstrumentDetail.isAutoLine) {
                (this.props.selectedInstrumentDetail.countData || []).map((data, index) => {
                    items.push(<th scope="col" key={index} ></th>);
                })
            } else {
                (this.props.selectedInstrumentDetail.positionCount || []).map((data, index) => {
                    items.push(<th scope="col" key={index} ></th>);
                })
            }

        }
        return items;
    }

    private createMeasuredColumnData = () => {
        const items: any[] = [];
        let countData = this.props.selectedInstrumentDetail.countData.find(x => x.selected);
        if (!countData) {
            countData = this.props.selectedInstrumentDetail.countData[0];
        }
        let selectedDirection: any;
        if (countData !== undefined) {
            selectedDirection = countData.directions.find(x => x.selected);
        }
        let selectedPosition = this.props.selectedInstrumentDetail.positionCount.find(x => x.selected);
        if (!selectedPosition) {
            selectedPosition = this.props.selectedInstrumentDetail.positionCount[0];
        }
        let properties = [];
        const filteredProps = Utility.getUniquePropertiesFromList(this.props.selectedInstrumentDetail.properties);
        if (this.props.details) {
            properties = filteredProps.filter(x => {
                if (selectedDirection !== undefined) {
                    if (selectedDirection.name === "All") {
                        return x
                    } else {
                        return x.directionId === selectedDirection.id
                    }
                } else {
                    if (x.name === "All") {
                        return x
                    } else {
                        return x
                    }
                }
            });
        } else {
            properties = filteredProps;
        }
   
        if (selectedPosition !== undefined) {
            this.setState({
                totalmeasuredproperty: [...properties],
                measuredproperty: [...properties.filter((item, index) => index < 5)]
            })
        } else {
            this.setState({
                totalmeasuredproperty: [...properties],
                measuredproperty: [...properties.filter((item, index) => index < 5)]
            })
        }
    }

    createMeasuredColumnDataGraph(data: any, index: any) {
        const filteredProps = Utility.getUniquePropertiesFromList(this.props.selectedInstrumentDetail.properties)
        const trendData = []
        let propertyDetails: any = {};
        this.props.selectedInstrumentDetail?.positionMeans?.forEach((item: any) => {
            if (data.id === item.propertyId) {
                propertyDetails = filteredProps.find(x => item.propertyId === x.id);
                trendData.push(
                    {
                        xValue: item.positionName ? item.positionName : item.position.toString(),
                        value: item.mean
                    }
                )
            }
        })
        if (trendData.length != 0) {
            trendData.push({ xValue: "", value: _.last(this.props.selectedInstrumentDetail?.positionMeans)?.mean });
        }
        const yValue: number[] = [propertyDetails.alarmLow1, propertyDetails.alarmLow2, propertyDetails.alarmHigh1, propertyDetails.alarmHigh2, propertyDetails.rejectLow, propertyDetails.rejectHigh];
        trendData.forEach((item: any) => {
            yValue.push(item.value)
        })

        const minYValue: any = _.min(yValue) - (_.min(yValue) / 100 * 5);
        const maxYValue: any = _.max(yValue) + (_.max(yValue) / 100 * 5);

        const series1: ISeries[] = [
            {
                name: 'Mean',
                color: '#5ABFAE',
                id: '1',
                markerStyle: {
                    type: this.state?.chartType ==="Bar" ? "None" : "Circle"
                },
                yAxis: {
                    min: minYValue,
                    max: maxYValue,
                    decimalPlaces: propertyDetails?.decimals
                },
                dataLimits: [
                    {
                        name: 'Alarm Low Limit-1',
                        shownInChart: true,
                        value: propertyDetails.alarmLow1,
                        className: "custom-line-graph",
                        style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm Low 1" || x.name === "Alarm Limit1").colorCode }
                    },
                    {
                        name: 'Alarm High Limit-1',
                        shownInChart: true,
                        value: propertyDetails.alarmHigh1,
                        className: "custom-line-graph",
                        style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm High 1" || x.name === "Alarm Limit1").colorCode }
                    },
                    {
                        name: 'Alarm Low Limit-2',
                        shownInChart: true,
                        value: propertyDetails.alarmLow2,
                        className: "custom-line-graph",
                        style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm Low 2" || x.name === "Alarm Limit2").colorCode }
                    },
                    {
                        name: 'Alarm High Limit-2',
                        shownInChart: true,
                        value: propertyDetails.alarmHigh2,
                        className: "custom-line-graph",
                        style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm High 2" || x.name === "Alarm Limit2").colorCode }
                    },
                    {
                        name: 'Reject Low',
                        shownInChart: true,
                        value: propertyDetails.rejectLow,
                        className: "custom-line-graph",
                        style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Reject Low" || x.name === "Reject Limit").colorCode }
                    },
                    {
                        name: 'Reject High',
                        shownInChart: true,
                        value: propertyDetails.rejectHigh,
                        className: "custom-line-graph",
                        style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Reject High" || x.name === "Reject Limit").colorCode }
                    }
                ],
                isShownInChart: true,
                points: trendData
            }
        ];
        return <tr style={{ height: "150px" }} key={Math.random()}>
            <td className="trend-table">
                {series1[0].points?.length > 0 ? <Trend
                    chartType={this.state.chartType}
                    invalidPointLineType='None'
                    invalidStatuses={['Invalid']}
                    dateUnit={this.state.dateUnit}
                    dateUnitCount={this.state.dateUnitCount}
                    gridLineColor='grey'
                    gridLineWidth={0.5}
                    showVerticalGridLines={false}
                    showHorizontalGridLines={true}
                    series={series1}
                    xAxis={{ type: 'Ordinal', tickAngle: 45, height: 60 }}
                    onChartTypeChange={this.onChartTypeChange}
                    onDataLimitVisibilityChange={this.onDataLimitVisibilityChange}
                    onDateRangeChange={this.onDateRangeChange}
                    onInvalidPointTypeChange={this.onInvalidPointTypeChange}
                    onSeriesChartTypeChange={this.onSeriesChartTypeChange}
                    onSeriesColorChange={this.onSeriesColorChange}
                    onSeriesFillTypeChange={this.onSeriesFillTypeChange}
                    onSeriesMarkerChange={this.onSeriesMarkerChange}
                    trendChartHeight={150}
                    showChartType={false}
                    showDateTimePicker={false}
                    showOuterBorder={false}
                    showTableData={false}
                    yAxisTicksCount={2}
                    yAxisWidth={75}
                />
                    : <div>
                        <NoTrendToDisplay></NoTrendToDisplay>
                    </div>}
            </td>
        </tr>
    }

    // =======================================================================================

    onDateRangeChange = (start: string | number | Date, end: string | number | Date, dateUnit: DateUnits, dateUnitCount: number, isOnZoom: boolean) => {
        this.setState({
            dateUnit,
            dateUnitCount,
            start: start as Date,
            end: end as Date
        });
    }


    onDataLimitVisibilityChange = (series: ISeries, limit: ITrendDataLimit, isShown: boolean) => {
        let updatedValue = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                let limits = item.dataLimits.map(((line: ITrendDataLimit) => {
                    if (line.name === limit.name) {
                        return { ...line, shownInChart: isShown };
                    } else {
                        return line;
                    }
                }))
                return { ...item, dataLimits: limits }
            } else {
                return item;
            }
        });

        this.setState({ series: updatedValue });
    }

    onChartTypeChange = (chartType: ChartTypes) => {
        this.setState({
            chartType: chartType
        });
        return chartType;
    }

    onSeriesChartTypeChange = (value: string, series: ISeries) => {
        let updatedValue: ISeries[] = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                return { ...item, chartType: value } as ISeries;
            } else {
                return item;
            }
        });
        this.setState({ series: updatedValue });
    }

    onSeriesColorChange = (value: string, series: ISeries) => {
        let updatedValue: ISeries[] = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                return { ...item, color: value } as ISeries;
            } else {
                return item;
            }
        });
        this.setState({ series: updatedValue });
    }

    getMarkerStyles = (value: string, item: ISeries) => {
        let marker = item.markerStyle ? { ...item.markerStyle } : {};
        if (value === "Circle") {
            marker.type = "Circle";
            marker.fillColor = "white";
        } else if (value === "Square") {
            marker.type = "Square";
            marker.fillColor = "white";
        } else if (value === "FillCircle") {
            marker.type = "Circle";
            marker.fillColor = "SeriesColor";
        } else if (value === "FillSquare") {
            marker.type = "Square";
            marker.fillColor = "SeriesColor";
        } else {
            marker.type = "None";
        }
        return marker;
    }

    onSeriesMarkerChange = (value: TrendMarkerTypes, series: ISeries) => {
        let updatedValue: ISeries[] = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                return { ...item, markerStyle: { ...series.markerStyle, type: value } } as ISeries;
            } else {
                return item;
            }
        });
        this.setState({ series: updatedValue });
    }

    onSeriesFillTypeChange = (value: string, series: ISeries) => {
        let updatedValue: ISeries[] = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                return { ...item, fillType: value } as ISeries;
            } else {
                return item;
            }
        });
        this.setState({ series: updatedValue });
    }

    onInvalidPointTypeChange = (value: string, series: ISeries) => {
        let updatedValue: ISeries[] = this.state.series.map((item: any) => {
            if (item.name === series.name) {
                return { ...item, invalidPointLineType: value } as ISeries;
            } else {
                return item;
            }
        });
        this.setState({ series: updatedValue });
    }


    generateOrdinalData(fromDate: number, toDate: number, interval = 1, min: number, max: number, isNumber = false) {
        const data = [];
        let i = 0;
        while (fromDate < toDate) {
            const obj = {
                xValue: isNumber ? fromDate : 'Sample' + fromDate,
                value: parseInt((Math.random() * (max - min) + min).toString()) + 0.44444444,
                status: ['Valid', 'Invalid', 'Good'][i % 3],
                customValue: ['Reel', 'Machine', 'Paper'][i % 3]
            };
            data.push(obj);
            fromDate = fromDate + interval;
            i++;
        }
        return data;
    }

    generateOrdinalData1(fromDate: number, toDate: number, interval = 1, min: number, max: number, isNumber = false) {
        const data = [
            {
                xValue: "Position",
                value: 50
            }
        ];
        return data;
    }

    generateData(fromDate: Date, toDate: Date, interval = 180000, min: number, max: number) {
        const data = [];
        let i = 0;
        while (fromDate.getTime() < toDate.getTime()) {
            const obj = {
                xValue: new Date(fromDate),
                value: parseInt((Math.random() * (max - min) + min).toString()) + 0.44444444,
                status: ['Valid', 'Invalid', 'Good'][i % 3],
                customValue: ['Reel', 'Machine', 'Paper'][i % 3]
            };
            data.push(obj);
            fromDate = new Date(fromDate.getTime() + interval);
            i++;
        }
        return data;
    }

    // ==========================================================================================

    public createData(propertyId: any, propertyName: string, selectedDirection: any, selectedPosition: any, directionId?: string) {
        const items: any[] = [];
        if (this.props.details) {
            if (selectedDirection !== undefined) {
                for (let index = 0; index < selectedDirection?.maxCount; index++) {
                    const readings = this.props.selectedInstrumentDetail.readings;
                    // // properties and directionCounts
                    let dirC: any[] = [];
                    if (selectedDirection.name === "All") {
                        dirC = this.props.selectedInstrumentDetail.directionCounts.filter(x => x.position === selectedPosition.position && x.direction.id == directionId);
                    }
                    let indexNumber = 0;
                    dirC.map((element: any) => {
                        const checkDirection = propertyName.search(element.direction.name)
                        if (checkDirection !== -1) {
                            indexNumber = element.totalCounts
                        }
                    })
                    let mainData;
                    if (readings.length > 0) {
                        if (selectedDirection.name === "All") {
                            if (this.props.selectedInstrumentDetail.isAutoLine) {
                                const countData = this.props.selectedInstrumentDetail.countData.find(x => x.selected === true);
                                const dirCount = this.props.selectedInstrumentDetail.directionCounts.find(x => x.name === countData.positionName);
                                this.props.selectedInstrumentDetail.readings.map((x) => {
                                    if (x.propertyId === propertyId && x.count === index + 1
                                        && x.position === dirCount.position && x.positionName === dirCount.name) {
                                        mainData = x;
                                    }
                                })
                            } else {
                                mainData = readings.find(x => x.count === index + 1 && x.propertyId === propertyId && x.position === selectedPosition.position && x.directionId === directionId);
                            }
                        } else {
                            mainData = readings.find(x => x.count === index + 1 && x.propertyId === propertyId &&
                                x.directionId === selectedDirection.id && x.position === selectedPosition.position);
                        }
                    }
                    const data = mainData !== undefined && mainData.value != null && !isNaN(mainData.value) ? mainData.value.toFixed(mainData.decimals) : indexNumber <= index ? CONSTANTS.NOTCONSIDEREDFORCALC : CONSTANTS.NOTCONSIDEREDFORCALC;
                    let color = "black";
                    if (mainData !== undefined) {
                        if (mainData.valueRange.name === "Alarm Limit1") {
                            color = this.props.thresholdSettings.find(x => x.name === "Alarm Limit1")?.colorCode;
                        } else if (mainData.valueRange.name === "Alarm Limit2") {
                            color = this.props.thresholdSettings.find(x => x.name === "Alarm Limit2")?.colorCode;
                        } else if (mainData.valueRange.name === "Reject Limit") {
                            color = this.props.thresholdSettings.find(x => x.name === "Reject Limit")?.colorCode;
                        }
                    }

                    items.push(<td scope="col" key={index}><span style={{ color }}>{data}</span></td>);
                }

            }
        } else {
            for (let index = 0; index < this.props.selectedInstrumentDetail.countData.length; index++) {
                const countData = this.props.selectedInstrumentDetail.countData.find(x => x.index === index);
                let dirCount: any;
                if (countData !== undefined) {
                    dirCount = this.props.selectedInstrumentDetail.directionCounts.find(x => x.name === countData.positionName && x.direction.id === directionId);
                }
                let data: any;
                let dirC: any[] = [];
                if (selectedDirection.name === "All") {
                    dirC = this.props.selectedInstrumentDetail.directionCounts.filter(x => x.position === selectedPosition.position && x.direction.id === directionId);
                }
                let indexNumber = 0;
                dirC.map((element: any) => {
                    const checkDirection = propertyName.search(element.direction.name)
                    if (checkDirection !== -1) {
                        indexNumber = element.totalCounts
                    }
                })
                var allValueRangesForAPosition: any[] = [];
                this.props.selectedInstrumentDetail.readings.map((x) => {
                    if (dirCount !== undefined) {
                        if (x.propertyId === propertyId && x.positionName === dirCount.name && x.position === index) {
                            allValueRangesForAPosition.push(x);
                        }
                    }
                });

                var color = this.getRightColorForDashboardView(allValueRangesForAPosition);
                var selectedProperty = this.props.selectedInstrumentDetail?.properties?.find(x => x.id === propertyId);
                const posMean1 = this.props.selectedInstrumentDetail.statistics.find(x => x.propertyId === propertyId && x.position === index && x.directionId === directionId)
                const mean = posMean1 !== undefined ?
                    (!isNaN(posMean1?.mean) ? posMean1?.mean?.toFixed(selectedProperty?.decimals) : CONSTANTS.NOTCONSIDEREDFORCALC)
                    : indexNumber <= index ? CONSTANTS.NOTCONSIDEREDFORCALC : CONSTANTS.NOTCONSIDEREDFORCALC;
                items.push(<td scope="col" key={index} >
                    <span style={{ color }} >{mean}</span>
                </td>);
            }
        }
        return items;
    }
    // MEASURED END

    /// Get right color to show in dashboard screen.
    /// Dashboard measurement statistics will not have direct value status, so need to pick right color by looking in all available positions
    /// default color is black
    private getRightColorForDashboardView(allValueRangesForAPosition: any[]): string {
        let color = CONSTANTS.WITHIN_LIMIT_COLOR;
        if (allValueRangesForAPosition?.filter(x => x?.valueRange?.name === CONSTANTS.ValueRange.AlarmLimit1)?.length > 0) {
            color = this.props.thresholdSettings.find(x => x.name === "Alarm Limit1")?.colorCode;
        }
        else if (allValueRangesForAPosition?.filter(x => x?.valueRange?.name === CONSTANTS.ValueRange.AlarmLimit2)?.length > 0) {
            color = this.props.thresholdSettings.find(x => x.name === "Alarm Limit2")?.colorCode;
        }
        else if (allValueRangesForAPosition?.filter(x => x?.valueRange?.name === CONSTANTS.ValueRange.RejectLimit)?.length > 0) {
            color = this.props.thresholdSettings.find(x => x.name === "Reject Limit")?.colorCode;
        }
        return color;
    }

    // KEYEDIN START
    private createKeyedInHeader() {
        const items: any[] = [];
        if (this.props.details) {
            const selectedPosition = this.props.selectedKeyedInDetails.positionCounts.find(x => x.selected);
            const countData = this.props.selectedKeyedInDetails.countData.find(x => x.selected);
            const selectedDirection = countData.directions.find(x => x.selected);
            if (selectedPosition !== undefined && selectedDirection !== undefined) {
                for (let index = 1; index <= selectedDirection.totalCounts; index++) {
                    items.push(<th scope="col" key={index}></th>);
                }
            }
        } else {
            (this.props.selectedKeyedInDetails.positionCounts || []).map((data, index) => {
                items.push(<th scope="col" key={index}></th>);
            })
        }

        return items;
    }

    private createKeyedInColumnData(selectedKeyedInDetails: IKeyedInDetails, countValue: any,
        setOnchange: (e: any, count: number, propertyId: string, item: any) => void,
        onKeyedInCountSubmit: (data: any) => void
    ) {
        const items: any[] = [];
        const trendData = [];
        let propertyDetails: any = {};
        if (this.props.selectedKeyedInDetails.positionMeans?.length != 0) {
            this.props.selectedKeyedInDetails.positionMeans.forEach((item: any) => {
                trendData.push(
                    {
                        xValue: item.positionName ? item.positionName : item.position.toString(),
                        value: item.mean
                    }
                )
            })

            propertyDetails = this.props.keyedInSampleData.find(x => x.id == this.props.selectedKeyedInDetails.id);

            if (trendData.length != 0) {
                trendData.push({ xValue: "", value: _.last(this.props.selectedKeyedInDetails.positionMeans)?.mean });
            }

            const yValue: number[] = [propertyDetails.alarmLow1, propertyDetails.alarmLow2, propertyDetails.alarmHigh1, propertyDetails.alarmHigh2, propertyDetails.rejectLow, propertyDetails.rejectHigh];
            trendData.forEach((item: any) => {
                yValue.push(item.value)
            })

            const minYValue: any = _.min(yValue) - (_.min(yValue) / 100 * 5);
            const maxYValue: any = _.max(yValue) + (_.max(yValue) / 100 * 5);

            const series1: any = [
                {
                    name: 'Mean',
                    color: '#5ABFAE',
                    id: '1',
                    markerStyle: {
                        type: this.state?.chartType ==="Bar" ? "None" : "Circle"
                    },
                    yAxis: {
                        min: minYValue,
                        max: maxYValue,
                        decimalPlaces: propertyDetails?.decimals
                    },
                    dataLimits: [
                        {
                            name: 'Alarm Low Limit-1',
                            shownInChart: true,
                            value: propertyDetails.alarmLow1,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm Low 1" || x.name === "Alarm Limit1").colorCode }
                        },
                        {
                            name: 'Alarm High Limit-1',
                            shownInChart: true,
                            value: propertyDetails.alarmHigh1,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm High 1" || x.name === "Alarm Limit1").colorCode }
                        },
                        {
                            name: 'Alarm Low Limit-2',
                            shownInChart: true,
                            value: propertyDetails.alarmLow2,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm Low 2" || x.name === "Alarm Limit2").colorCode }
                        },
                        {
                            name: 'Alarm High Limit-2',
                            shownInChart: true,
                            value: propertyDetails.alarmHigh2,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm High 2" || x.name === "Alarm Limit2").colorCode }
                        },
                        {
                            name: 'Reject Low',
                            shownInChart: true,
                            value: propertyDetails.rejectLow,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Reject Low" || x.name === "Reject Limit").colorCode }
                        },
                        {
                            name: 'Reject High',
                            shownInChart: true,
                            value: propertyDetails.rejectHigh,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Reject High" || x.name === "Reject Limit").colorCode }
                        }
                    ],
                    isShownInChart: true,
                    points: trendData
                }
            ];

            items.push(<tr style={{ height: "150px" }} className="normal-class" key={Math.random()}>
                <td className="trend-table">
                    {series1[0].points?.length > 0 ? <Trend
                        chartType={this.state.chartType}
                        invalidPointLineType='None'
                        invalidStatuses={['Invalid']}
                        dateUnit={this.state.dateUnit}
                        dateUnitCount={this.state.dateUnitCount}
                        gridLineColor='grey'
                        gridLineWidth={0.5}
                        showVerticalGridLines={false}
                        showHorizontalGridLines={true}
                        series={series1}
                        xAxis={{ type: 'Ordinal', tickAngle: 45, height: 60 }}
                        onChartTypeChange={this.onChartTypeChange}
                        onDataLimitVisibilityChange={this.onDataLimitVisibilityChange}
                        onDateRangeChange={this.onDateRangeChange}
                        onInvalidPointTypeChange={this.onInvalidPointTypeChange}
                        onSeriesChartTypeChange={this.onSeriesChartTypeChange}
                        onSeriesColorChange={this.onSeriesColorChange}
                        onSeriesFillTypeChange={this.onSeriesFillTypeChange}
                        onSeriesMarkerChange={this.onSeriesMarkerChange}
                        trendChartHeight={150}
                        showChartType={false}
                        showDateTimePicker={false}
                        showOuterBorder={false}
                        showTableData={false}
                        yAxisTicksCount={2}
                        yAxisWidth={75}
                    />
                        : <div>
                            <NoTrendToDisplay></NoTrendToDisplay>
                        </div>
                    }
                </td>

            </tr>);
            return items;
        } else {
            return null;
        }
    }
    // KEYEDIN END

    // CALCULATED DSTART
    private createCalculatedHeader() {
        const items: any[] = [];
        for (let index = 0; index < this.props.selectedCalculatedDetails.calculatedValues.length; index++) {
            items.push(<th scope="col" key={index}><span></span></th>);
        }
        return items;
    }

    private createCalculatedColumnData() {
        const items: any[] = [];
        const trendData: any = [];
        if (this.props.selectedCalculatedDetails.calculatedValues?.length != 0) {
            this.props.selectedCalculatedDetails.calculatedValues.forEach((item: any) => {
                trendData.push(
                    {
                        xValue: item.positionName ? item.positionName : item.count.toString(),
                        value: item.value
                    }
                )
            })
            if (trendData.length != 0) {
                trendData.push({ xValue: "", value: _.last(this.props.selectedCalculatedDetails.calculatedValues)?.value });
            }
            const propertyDetails: any = this.props.selectedCalculatedDetails;

            const yValue: number[] = [propertyDetails.alarmLow1, propertyDetails.alarmLow2, propertyDetails.alarmHigh1, propertyDetails.alarmHigh2, propertyDetails.rejectLow, propertyDetails.rejectHigh];
            trendData.forEach((item: any) => {
                yValue.push(item.value)
            })

            const minYValue: any = _.min(yValue) - (_.min(yValue) / 100 * 5);
            const maxYValue: any = _.max(yValue) + (_.max(yValue) / 100 * 5);

            const series1: any = [
                {
                    name: 'Mean',
                    color: '#5ABFAE',
                    id: '1',
                    markerStyle: {
                        type: this.state?.chartType ==="Bar" ? "None" : "Circle"
                    },
                    yAxis: {
                        min: minYValue,
                        max: maxYValue,
                        decimalPlaces: this.props.selectedCalculatedDetails?.decimals

                    },
                    dataLimits: [
                        {
                            name: 'Alarm Low Limit-1',
                            shownInChart: true,
                            value: propertyDetails.alarmLow1,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm Low 1" || x.name === "Alarm Limit1").colorCode }
                        },
                        {
                            name: 'Alarm High Limit-1',
                            shownInChart: true,
                            value: propertyDetails.alarmHigh1,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm High 1" || x.name === "Alarm Limit1").colorCode }
                        },
                        {
                            name: 'Alarm Low Limit-2',
                            shownInChart: true,
                            value: propertyDetails.alarmLow2,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm Low 2" || x.name === "Alarm Limit2").colorCode }
                        },
                        {
                            name: 'Alarm High Limit-2',
                            shownInChart: true,
                            value: propertyDetails.alarmHigh2,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Alarm High 2" || x.name === "Alarm Limit2").colorCode }
                        },
                        {
                            name: 'Reject Low',
                            shownInChart: true,
                            value: propertyDetails.rejectLow,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Reject Low" || x.name === "Reject Limit").colorCode }
                        },
                        {
                            name: 'Reject High',
                            shownInChart: true,
                            value: propertyDetails.rejectHigh,
                            className: "custom-line-graph",
                            style: { stroke: this.props.thresholdSettings?.find(x => x.name === "Reject High" || x.name === "Reject Limit").colorCode }
                        }
                    ],
                    isShownInChart: true,
                    points: trendData
                }
            ];

            items.push(<tr style={{ height: "150px" }} className="normal-class" key={Math.random()}>
                <td className="trend-table">
                    {series1[0].points?.length > 0 ? <Trend
                        chartType={this.state.chartType}
                        invalidPointLineType='None'
                        invalidStatuses={['Invalid']}
                        dateUnit={this.state.dateUnit}
                        dateUnitCount={this.state.dateUnitCount}
                        gridLineColor='grey'
                        gridLineWidth={0.5}
                        showVerticalGridLines={false}
                        showHorizontalGridLines={true}
                        series={series1}
                        xAxis={{ type: 'Ordinal', tickAngle: 45, height: 60 }}
                        onChartTypeChange={this.onChartTypeChange}
                        onDataLimitVisibilityChange={this.onDataLimitVisibilityChange}
                        onDateRangeChange={this.onDateRangeChange}
                        onInvalidPointTypeChange={this.onInvalidPointTypeChange}
                        onSeriesChartTypeChange={this.onSeriesChartTypeChange}
                        onSeriesColorChange={this.onSeriesColorChange}
                        onSeriesFillTypeChange={this.onSeriesFillTypeChange}
                        onSeriesMarkerChange={this.onSeriesMarkerChange}
                        trendChartHeight={150}
                        showChartType={false}
                        showDateTimePicker={false}
                        showOuterBorder={false}
                        showTableData={false}
                        yAxisTicksCount={2}
                        yAxisWidth={75}
                    />
                        : <div>
                            <NoTrendToDisplay></NoTrendToDisplay>
                        </div>}
                </td>

            </tr>);
            return items;
        } else {
            return null;
        }
    }



    public fetchMore = () => {
        this._page = this._page + 1;
        const mProperty = this.state.totalmeasuredproperty.filter((item: any, index: number) => index < 5 * this._page).length;
        if (mProperty === this.state.totalmeasuredproperty.length) {
            this._hasData = false;
        }
        this.setState({
            measuredproperty: [...this.state.totalmeasuredproperty.filter((item: any, index: number) => index < 5 * this._page)]
        })
    }

    public render() {

        return (
            <Translation>
                {
                    t =>
                        <React.Fragment>

                            {this.props.selectedInstrumentDetail?.isAutoLine ?
                                <div>
                                    <div className="w-100" id="content-data-property" >
                                        <div className={this.props.details ? "overflow-auto transClass" : "rowAutoline autolineScrollBottom"}
                                            id="autolinescroll"
                                            ref={this._autolineScroll}>
                                            {this.props.measuredSection ?
                                                <InfiniteScroll
                                                    dataLength={this.state.measuredproperty.length} //This is important field to render the next data
                                                    next={this.fetchMore}
                                                    hasMore={this._hasData}
                                                    loader={<div><h6 style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center' }}><Spinner color='blue' sizeClass='medium' /></h6><div></div></div>}
                                                    scrollThreshold={0.6}
                                                    scrollableTarget="scrollableDivs">
                                                    <table className=
                                                        {this.props.details ? "transClass measurement-tbl measurement-tbl-autoline one" :
                                                            "measurement-tbl measurement-tbl-autoline one"}>
                                                        <thead>
                                                            <tr>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.measuredproperty.map((data: any, index: any) => {
                                                              
                                                                    return this.createMeasuredColumnDataGraph(data, index)
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </InfiniteScroll>
                                                : null}

                                            {this.props.keyedInSection ?
                                                <table className={this.props.details ? "transClass measurement-tbl" : "measurement-tbl measurement-tbl-keyedin"}>
                                                    <thead>
                                                        <tr key={Math.random()}>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <AppContextConsumer>
                                                            {({ selectedKeyedInDetails, countValue, setOnchange, onKeyedInCountSubmit }) =>
                                                                this.createKeyedInColumnData(selectedKeyedInDetails, countValue, setOnchange, onKeyedInCountSubmit)}
                                                        </AppContextConsumer>
                                                    </tbody>
                                                </table> : null}

                                            {this.props.calculatedSection ?
                                                <table className={this.props.details ? "transClass measurement-tbl one" : "measurement-tbl one"} >
                                                    <thead>
                                                        <tr>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.createCalculatedColumnData()}
                                                    </tbody>
                                                </table> : null
                                            }

                                        </div>
                                    </div>
                                </div> :
                                <div className="layout-res-measurement">
                                    <div
                                        className={this.props.details ? "overflow-auto abb-wrapper transClass" : "rowAutoline autolineScrollBottom"}
                                        id="autolinescroll"
                                        ref={this._autolineScroll}
                                    >
                                        {this.props.measuredSection ?
                                            <InfiniteScroll
                                                dataLength={this.state.measuredproperty.length} //This is important field to render the next data
                                                next={this.fetchMore}
                                                hasMore={this._hasData}
                                                loader={<div><h6 style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center' }}><Spinner color='blue' sizeClass='medium' /></h6><div></div></div>}
                                                scrollThreshold={0.6}
                                                scrollableTarget="scrollableDivs">
                                                <table className=
                                                    {this.props.details ? "transClass measurement-tbl one" : " measurement-tbl one"}>
                                                    <thead>
                                                        <tr>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.measuredproperty.map((data: any, index: any) => {
                                                                return this.createMeasuredColumnDataGraph(data, index)
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </InfiniteScroll>
                                            : null}

                                        {this.props.keyedInSection ?
                                            <table className={this.props.details ? "transClass measurement-tbl" : "measurement-tbl measurement-tbl-keyedin"}>
                                                <thead>
                                                    <tr key={Math.random()}>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <AppContextConsumer>
                                                        {({ selectedKeyedInDetails, countValue, setOnchange, onKeyedInCountSubmit }) =>
                                                            this.createKeyedInColumnData(selectedKeyedInDetails, countValue, setOnchange, onKeyedInCountSubmit)}
                                                    </AppContextConsumer>
                                                </tbody>
                                            </table> : null}

                                        {this.props.calculatedSection ?
                                            <table className={this.props.details ? "transClass measurement-tbl one" : "measurement-tbl one"} >
                                                <thead>
                                                    <tr>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.createCalculatedColumnData()}
                                                </tbody>
                                            </table> : null
                                        }
                                    </div>
                                </div>}

                        </React.Fragment>
                }
            </Translation>
        )
    }
}